import { takeLatest } from 'redux-saga/effects';
import {
    DOWNLOAD_CLAIM_REQUEST,
    FETCH_CLAIMS_REQUEST,
    SAVE_CLAIMS_AS_BUNDLE_REQUEST,
} from '../../redux/modules/claims/claims-actions';
import { createClaimBundles, fetchClaimListWorker } from './claimsWorkerSaga';
import { commonGetWorkerSaga } from '../commonSaga/commonWorkerSaga';

export function* fetchClaimsListWatcher() {
    yield takeLatest(FETCH_CLAIMS_REQUEST, fetchClaimListWorker);
}

export function* downloadClaimsWatcher() {
    yield takeLatest(DOWNLOAD_CLAIM_REQUEST, commonGetWorkerSaga);
}

export function* saveClaimsBundleWatcher() {
    yield takeLatest(SAVE_CLAIMS_AS_BUNDLE_REQUEST, createClaimBundles);
}
